import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export const parsePigEnvironment = (config: Record<string, string>): Environment => ({
  ...parseAgrEnvironment(config),
  NEDAP_BASE_URL: config.NEDAP_BASE_URL,
  NEDAP_CLIENT_ID: config.NEDAP_CLIENT_ID,
  NEDAP_REDIRECT_URI: config.NEDAP_REDIRECT_URI,
  NEDAP_WORKSPACE_ID: config.NEDAP_WORKSPACE_ID,
  NEDAP_REPORT_ID: config.NEDAP_REPORT_ID,
});
